/* globals angular, _, $ */
(function() {
  'use strict';

  function ReverseFormV2Ctrl(
    $scope,
    $rootScope,
    $mdToast,
    $uibModal,
    $state,
    $stateParams,
    Historico,
    Correios,
    Pedido,
    Perfil,
    localStorageService) {

    $rootScope.msgSuccessReverse = false;

    Date.prototype.addDays = function(days) {
      var dat = new Date(this.valueOf());
      dat.setDate(dat.getDate() + days);
      return dat;
    }

    var vm = this;
    var MODALIDADE = 'AUTORIZACAO_POSTAGEM';
    // v2 usa o correios-services para os endpoints de reversa
    vm.reverseService = Correios;
    vm.canShowOptions = false;
    vm.reverse = {
      modalidade: MODALIDADE,
      remetente: {
        endereco: {}
      }
    }

    // Set init state
    vm.original = {
      packageId: null,
      orderId: null,
    };

    vm.deliveryTypes = [];
    vm.selectedDeliveryType = null;
    vm.seguro = null;
    vm.documentoFiscal = null;
    vm.produtosList = [];

    function _init() {
      if($stateParams.originalPackageId && $stateParams.originalOrderId) {
        vm.original.packageId = $stateParams.originalPackageId;
        vm.original.orderId = $stateParams.originalOrderId;
      }

      _getUserAddresses();
    }

    vm.reset = function () {
      vm.reverse = {
        modalidade: MODALIDADE,
        remetente: {
          endereco: {}
        },
        deliveryType: null,
        comSeguro: false,
        valorDeclarado: null,
        comEmbalagem: false,
      }
    }

    vm.setDeliveryType = function(deliveryType) {
      vm.selectedDeliveryType = deliveryType;
    }

    vm.setSeguro = function(seguro) {
      vm.seguro = seguro;
    }

    vm.setDocumentoFiscal = function(doc) {
      vm.documentoFiscal = doc;
    }

    vm.setProdutos = function(produtos) {
      vm.produtosList = produtos;
    }

    vm.canShowOptionsChange = (x) => { vm.canShowOptions = x }

    vm.deliveryTypesChange = function(values) {
      vm.deliveryTypes = values.map(x => x.toJSON ? x.toJSON() : Object.assign({}, x));
    }

    vm.save = function() {

      vm.optionsFormSubmitted = true;

      if (!vm.selectedDeliveryType) {
        _showAlert("Ops, alguns campos não foram preenchidos corretamente");
        return;
      }

      if (!vm.seguro || !vm.seguro.valido) {
        _showAlert("Informe um valor declarado entre R$18,00 e R$10.000,00 ou desmarque o seguro");
        return;
      }

      if (!vm.documentoFiscal) {
        _showAlert("Ops, alguns campos não foram preenchidos corretamente");
        return;
      }

      if (vm.documentoFiscal.tipo === 'jaTemDocumento' && (!vm.documentoFiscal.chave || vm.documentoFiscal.chave.length !== 44)) {
        _showAlert("Informe a chave de acesso com 44 dígitos");
        return;
      }

      vm.salvandoOn = true;

      vm.optionsFormSubmitted = false;
      vm.reverse.tipoEntrega = vm.selectedDeliveryType.tipo;
      vm.reverse.valorDeclarado = vm.seguro.comSeguro ? vm.seguro.valor : null;
      vm.reverse.chaveAcessoDocumentoOrigem = vm.documentoFiscal.tipo === 'jaTemDocumento' ? vm.documentoFiscal.chave : null;
      vm.reverse.produtos = (vm.produtosList || []).filter(function(p) { return p.descricao && p.descricao.trim(); });

      vm.reverse.remetente.endereco.codigoPostal = vm.reverse.remetente.endereco.codigoPostal.replace(/-/g, '');
      vm.reverse.remetente.endereco.pais = "Brasil";
      vm.reverse.destino.codigoPostal = vm.reverse.destino.codigoPostal.replace(/-/g, '');
      vm.reverse.destino.pais = "Brasil";
      vm.reverse.destinatario = {
        nome: vm.reverse.destino.nome,
        email: vm.user.email,
        endereco: vm.reverse.destino
      }

      vm.reverse.original = vm.originalPackage;

      Correios.saveReverse(vm.reverse)
      .then(function(data) {
        $rootScope.msgSuccessReverse = true;
        vm.salvandoOn = false;
        _showModalReverseAlert();
      })
      .catch(function(err){
        vm.salvandoOn = false;

        if(err.status == '422' && err.data.error && err.data.error.code == 'validation.constraints.cpf'){
          _showAlert("Ops, o documento informado é inválido");
        } else {
          _showAlert("Ops, não foi possível criar a reversa");
        }
      });
    }

    function _showModalReverseAlert() {
      if(localStorageService.cookie.get('checkAlertReverseCheck') == true) {
        $state.go("reverse-list");
        return;
      }

      $uibModal.open({
        animation: false,
        templateUrl: 'modalReverseAlert.html',
        controller: 'ReverseAlertCtrl',
        controllerAs: 'vm',
        resolve: {
          id: function() {return 'empty';}
        }
      })
      .result
      .then(function(data) {
          $state.go("reverse-list");
      });
    }

    function _getUserAddresses() {
      Perfil.getUserData()
      .then(function(user) {
        vm.user = user;
        vm.recipients = user.enderecos
        .filter(function(recipient) { return recipient.logisticaReversaHabilitada == true; })
        .map(function(recipient) { return Object.assign(recipient, { codigoPostal: recipient.cep }); });
      })
      .catch(function(err) {
        _showAlert("Não foi possível carregar os do seu usuário");
      });
    }

    function _showAlert(content) {
      var toast = $mdToast.simple()
        .textContent(content)
        .highlightAction(true)
        .parent('[data-container="toast"]')
        .position('top right')
        .hideDelay(5000);

      return $mdToast.show(toast);
    }

    _init();

    $scope.$watch('addressesForm.$valid', function(validity) {
      vm.addressesFormValid = validity;
      vm.allFormValid = vm.addressesFormValid && vm.optionsFormValid;
    });

    $scope.$watch('optionsForm.$valid', function(validity) {
      vm.optionsFormValid = validity;
      vm.allFormValid = vm.addressesFormValid && vm.optionsFormValid;
    });

    vm.cancel = function() {
      $uibModal.open({
        animation: false,
        template: require('../reverse-form/cancel-panel/cancel-panel.html'),
        controller: 'ReverseCancelCtrl',
        controllerAs: 'vm',
        windowClass: 'cancel-panel',
        resolve: {
          id: function() {return 'empty';}
        }
      })
      .result
      .then(function(data) {
          $state.go("reverse-list");
      });
    }
  }

  angular
    .module('mandaeApp')
    .controller('ReverseFormV2Ctrl', ReverseFormV2Ctrl);

}());
